import { School, User, Loader2 } from "lucide-react";
import type { UserData } from "../types";

interface SchoolInfoSectionProps {
  isDark: boolean;
  activeProfile: any;
  userData: UserData | null;
  loadingUser: boolean;
  professorName: string;
  onProfessorNameChange: (value: string) => void;
}

export const SchoolInfoSection: React.FC<SchoolInfoSectionProps> = ({
  isDark,
  activeProfile,
  userData,
  loadingUser,
  professorName,
  onProfessorNameChange,
}) => {
  return (
    <div className="col-span-full bg-(--card-bg) border border-(--border-color) rounded-2xl p-6 shadow-sm mb-2">
      <div className="flex items-center gap-2 mb-6 border-b border-(--border-color) pb-4">
        <div className="p-2 rounded-lg bg-blue-50">
          <School className="w-5 h-5 text-(--primary-color)" />
        </div>
        <h3 className="font-semibold text-lg text-(--text-primary)">
          Dados da Instituição
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
            Escola / Instituição
          </label>
          <div className="w-full rounded-xl border p-3.5 flex items-center gap-3 bg-(--bg-secondary) border-transparent transition-all">
            <School className="w-5 h-5 text-(--text-tertiary)" />
            <span className="font-medium text-(--text-secondary)">
              {activeProfile?.name ||
                activeProfile?.institution ||
                "Nenhuma escola selecionada"}
            </span>
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
            Professor(a) Responsável
          </label>
          {loadingUser ? (
            <div className="w-full rounded-xl border p-3.5 flex items-center gap-3 bg-(--bg-secondary) border-transparent">
              <Loader2 className="w-5 h-5 animate-spin text-(--text-tertiary)" />
              <span className="text-(--text-tertiary)">
                Carregando dados...
              </span>
            </div>
          ) : (
            <div className="relative group">
              <input
                type="text"
                value={professorName}
                onChange={(e) => onProfessorNameChange(e.target.value)}
                className="w-full rounded-xl border border-(--border-color) p-3.5 pl-11 focus:ring-2 focus:ring-blue-500/20 focus:border-(--primary-color) outline-none transition-all hover:border-(--text-tertiary) font-medium text-(--text-primary) bg-(--card-bg)"
                placeholder="Nome completo do professor"
              />
              <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-(--text-tertiary) transition-colors group-focus-within:text-(--primary-color)" />
            </div>
          )}
        </div>
      </div>

      {userData && (
        <div className="mt-6 pt-4 border-t border-(--border-color) flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
          <p className="text-[11px] font-medium text-(--text-tertiary)">
            {userData.email}{" "}
            {userData.institution && `• ${userData.institution}`}{" "}
            {userData.city && `• ${userData.city}`}
          </p>
        </div>
      )}
    </div>
  );
};
